import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/fyp-2026-presentation-demo")({
  beforeLoad: () => {
    throw redirect({ to: "/" })
  },
})
